import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinbhosarimidc() {



  const cardData =
  {
    keyword: 'Corporate Cab Services in Bhosari MIDC',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Services in Bhosari MIDC',
    headingDescription: 'Pune Corporate Cars India Private Limited offers reliable and professional Corporate Cab Services in Bhosari MIDC, catering to manufacturing units, industrial plants, warehouses, and corporate offices in this busy industrial zone. Our fleet of well-maintained sedans, SUVs, and staff-transport vehicles ensures smooth and punctual daily commuting for employees, supervisors, clients, and executives. With trained chauffeurs, GPS-enabled vehicles, and flexible rental plans, we guarantee safe, efficient, and hassle-free transportation. Whether your company needs shift-based employee pickup and drop, dedicated corporate cars, VIP travel, or long-term mobility solutions, Pune Corporate Cars India Private Limited delivers high-quality and dependable cab services tailored to the needs of Bhosari MIDC.',

    top: 'Top Places to Visit in Pune with Pune Corporate Car',

    "topPlaces": [
    {
      "title": "Hinjewadi Rajiv Gandhi Infotech Park",
      "description": "Hinjewadi Phase 1, 2 and 3 together form Pune’s largest corporate ecosystem, home to global IT companies, MNCs, tech parks, and business hubs. With campuses of Infosys, Wipro, Cognizant, TCS and more, it is Pune’s primary employment corridor. The area has wide roads, 24×7 transport demand, cafes, business hotels, and constant corporate mobility needs — making it one of the busiest routes served by Pune Corporate Cars."
    },
    {
      "title": "Magarpatta Cybercity",
      "description": "Magarpatta Cybercity is a self-sustained corporate township combining IT parks, residential spaces, restaurants, and premium office buildings. Known for its clean, green, and secure environment, it hosts major IT giants like Accenture, Infosys, Capgemini and Barclays. Corporate travel requirements, employee drop services, and daily office commutes make it a major business hub in Pune."
    },
    {
      "title": "Kharadi EON IT Park",
      "description": "EON IT Park is Pune’s fastest-growing commercial destination, filled with high-rise IT towers, premium offices, and multinational companies. Its four major clusters (A, B, C, D) attract thousands of daily employees. With tech companies, co-working spaces, and international business centers, Kharadi is a top route for corporate pick-drop and airport transfers."
    },
    {
      "title": "Viman Nagar Business District",
      "description": "Viman Nagar is a premium corporate and lifestyle hub near Pune Airport, known for its modern business centers, coworking spaces, hotels, and commercial complexes. Major malls, restaurants, and connectivity to Kharadi, Koregaon Park, and Yerwada make it a preferred zone for corporate travel, meetings, and executive cab services."
    },
    {
      "title": "Baner–Balewadi Corporate Hub",
      "description": "Baner and Balewadi have transformed into Pune’s new-age commercial cluster with IT companies, startups, co-working hubs, and premium business towers. It offers a cosmopolitan corporate environment with cafés, boardrooms, and business hotels. The area’s proximity to Hinjewadi makes corporate cab requirements extremely high for daily office mobility."
    },
    {
      "title": "Chakan MIDC Industrial Area",
      "description": "Chakan MIDC is one of India’s biggest industrial and automobile manufacturing clusters, housing companies like Volkswagen, Mercedes-Benz, Bajaj, LG, and Mahindra. With 24×7 transport operations, staff shifts, and inter-plant travel, it is a prime location served by corporate cab services, staff shuttle operations, and industrial commute solutions."
    },
    {
      "title": "Talegaon MIDC",
      "description": "Talegaon MIDC is known for its global manufacturing units, auto plants, and logistics hubs. It hosts companies such as General Motors, L&T, JCB, and POSCO. The area witnesses heavy employee movement and frequent business visits from executives — making structured corporate mobility critical for smooth travel between Pune city and the MIDC."
    },
    {
      "title": "Yerwada Business Corridor",
      "description": "Yerwada is a major commercial zone with corporate towers, business parks, and high-end office spaces like ICC Tech Park and Commerzone. It is a preferred location for corporate meetings, finance companies, and consulting firms. Its close connectivity to the airport and EON makes it a frequent route for corporate cabs and executive travel."
    },
    {
      "title": "Koregaon Park Business & Lifestyle District",
      "description": "Koregaon Park blends premium business centers with high-end lifestyle spaces, cafés, and boutique offices. It attracts startups, creative agencies, international firms, and co-working workspaces. The area is ideal for board meetings, client visits, and VIP travel — heavily relying on professional chauffeur-driven cabs."
    },
    {
      "title": "Pimpri-Chinchwad Industrial Belt",
      "description": "PCMC is one of Pune’s strongest industrial belts, filled with auto, engineering, and manufacturing companies. Areas like Pimpri, Chinchwad, Bhosari, and Nigdi host major factories and R&D centers. With shift-based employee travel and factory visits, corporate cab services remain essential for day-to-day operations."
    }
  ],



"services": [
  {
    "name": "Bhosari Employee Transport",
    "description": "Bhosari Employee Transport offers reliable, safe, and professionally managed daily commuting solutions for employees working in Bhosari MIDC and surrounding industrial zones. With AC sedans, shuttle vans, and tempo travellers, we ensure punctual pickups, smooth routing, and secure travel across all shifts. Bhosari Employee Transport is ideal for companies seeking dependable and convenient mobility for their workforce."
  },
  {
    "name": "Bhosari Industrial Cab Service",
    "description": "Bhosari Industrial Cab Service provides structured and efficient cab services for factories, manufacturing plants, warehouses, and industrial units. Our service includes GPS-enabled AC vehicles, experienced chauffeurs, and optimized travel routes tailored for industrial operations. Bhosari Industrial Cab Service ensures seamless employee movement and professional travel support for management teams."
  },
  {
    "name": "Company Staff Cab Bhosari",
    "description": "Company Staff Cab Bhosari delivers customized transportation solutions for corporate and industrial staff. Whether it’s daily office commute, shift-based travel, or occasional travel requirements, our vehicles offer maximum comfort and safety. Company Staff Cab Bhosari ensures punctuality, clean interiors, and trained chauffeurs who understand industrial routes."
  },
  {
    "name": "Factory Worker Pickup Drop Bhosari",
    "description": "Factory Worker Pickup Drop Bhosari is designed specifically for factory workers traveling to and from manufacturing units in Bhosari MIDC. With early-morning, general, and night-shift support, our service ensures safe and timely commuting. Vehicles are well-maintained, monitored, and operated by disciplined drivers. Factory Worker Pickup Drop Bhosari boosts workforce reliability and punctuality."
  },
  {
    "name": "Corporate Shuttle Bhosari",
    "description": "Corporate Shuttle Bhosari provides high-capacity transportation using AC minibuses, vans, and tempo travellers for large employee groups. Perfect for factories, corporate parks, and industrial establishments, this service supports shift operations, fixed-route travel, and mass movement of staff. Corporate Shuttle Bhosari ensures organized, economical, and efficient workforce commuting."
  },
  {
    "name": "Business Taxi Bhosari MIDC",
    "description": "Business Taxi Bhosari MIDC offers premium cab services for corporate executives, managers, and clients visiting industrial units. With AC sedans and SUVs driven by trained chauffeurs, this service ensures professional, comfortable, and timely business travel. Business Taxi Bhosari MIDC supports meetings, factory visits, airport transfers, and inter-office travel."
  },
  {
    "name": "Employee Commute Bhosari",
    "description": "Employee Commute Bhosari provides structured daily commuting solutions with optimized routes, punctual pickups, and safety-focused operations. Our AC vehicles and professional drivers support early-morning, general, and night shifts. Employee Commute Bhosari ensures smooth travel and improves attendance and productivity for employees."
  },
  {
    "name": "Monthly Cab Service Bhosari",
    "description": "Monthly Cab Service Bhosari offers long-term cab rentals assigned exclusively to your company with dedicated drivers and predictable monthly billing. Ideal for executives, team leads, and daily commute needs, our service ensures uninterrupted availability and priority support. Monthly Cab Service Bhosari provides consistent and professional transportation throughout the month."
  },
  {
    "name": "Best Corporate Cabs Bhosari",
    "description": "Best Corporate Cabs Bhosari delivers premium and reliable cab services suited for industrial and corporate travel. Our sedans and SUVs ensure smooth, safe, and professional transportation for meetings, office travel, and executive mobility. Known for punctuality and service quality, Best Corporate Cabs Bhosari is trusted by businesses across Bhosari MIDC."
  },
  {
    "name": "Affordable Office Cabs Bhosari",
    "description": "Affordable Office Cabs Bhosari offers cost-effective cab services for daily travel, staff movement, and company operations. Despite economical pricing, all vehicles are fully sanitized, AC-equipped, and regularly maintained. This service helps companies reduce transportation costs while ensuring safe and comfortable employee commuting."
  },
  {
    "name": "Bhosari Industrial Fleet Service",
    "description": "Bhosari Industrial Fleet Service provides complete fleet management solutions including sedans, SUVs, vans, and tempo travellers dedicated to your organization. We handle driver allocation, vehicle maintenance, replacements, and route planning. Bhosari Industrial Fleet Service ensures centralized, efficient, and scalable mobility for industrial operations."
  },
  {
    "name": "Bhosari Outstation Cab",
    "description": "Bhosari Outstation Cab offers safe and comfortable long-distance travel for corporate meetings, client visits, and industrial site inspections. Our sedans and SUVs are ideal for destinations such as Pune, Nashik, Aurangabad, Kolhapur, and Mumbai. Bhosari Outstation Cab ensures timely, comfortable, and professional outstation travel."
  },
  {
    "name": "Sedan Cab Bhosari MIDC",
    "description": "Sedan Cab Bhosari MIDC provides premium sedans such as Dzire, Etios, Verna, and Honda City for executive and high-priority corporate travel. With plush seating, AC comfort, and smooth interiors, this service ensures a refined and reliable transportation experience. Sedan Cab Bhosari MIDC is ideal for meetings, airport transfers, and management mobility."
  },
  {
    "name": "SUV Cab Bhosari MIDC",
    "description": "SUV Cab Bhosari MIDC offers spacious and high-comfort SUVs like Ertiga, Innova, and Crysta for corporate movement, industrial visits, and long-distance travel. These vehicles provide superior legroom, strong AC, and luxury comfort suitable for corporate travel. SUV Cab Bhosari MIDC ensures premium and safe transportation."
  },
  {
    "name": "Corporate Fleet Provider Bhosari",
    "description": "Corporate Fleet Provider Bhosari delivers end-to-end fleet and driver management solutions for companies requiring multiple vehicles. We manage scheduling, replacements, maintenance, and real-time coordination. Corporate Fleet Provider Bhosari ensures cost-effective, smooth, and streamlined mobility operations for businesses in the industrial region."
  }
],
"tableData": [
  ["Bhosari Employee Transport", "Bhosari Industrial Cab Service"],
  ["Company Staff Cab Bhosari", "Factory Worker Pickup Drop Bhosari"],
  ["Corporate Shuttle Bhosari", "Business Taxi Bhosari MIDC"],
  ["Employee Commute Bhosari", "Monthly Cab Service Bhosari"],
  ["Best Corporate Cabs Bhosari", "Affordable Office Cabs Bhosari"],
  ["Bhosari Industrial Fleet Service", "Bhosari Outstation Cab"],
  ["Sedan Cab Bhosari MIDC", "SUV Cab Bhosari MIDC"],
  ["Corporate Fleet Provider Bhosari", ""]
],


  






"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Services in Bhosari MIDC",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited offers dependable and professional corporate cab services in Bhosari MIDC, ensuring smooth, safe, and timely transportation for employees and executives."
  },
  {
    "WhyChooseheading": "Ideal for Industrial & Manufacturing Companies",
    "WhyChoosedescription": "Our services are designed for the heavy industrial and manufacturing zone of Bhosari MIDC, providing reliable daily commuting solutions for shift and office staff."
  },
  {
    "WhyChooseheading": "Safe, Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All our cabs are regularly serviced, sanitized, and equipped to ensure a safe, hygienic, and comfortable travel experience."
  },
  {
    "WhyChooseheading": "Transparent & Affordable Pricing",
    "WhyChoosedescription": "We provide clear, competitive pricing with no hidden charges, ideal for daily, monthly, and long-term corporate travel needs."
  },
  {
    "WhyChooseheading": "Flexible Pick-Up & Drop Schedules",
    "WhyChoosedescription": "Choose from customized pickup and drop timings to match factory shifts, office hours, and employee schedules in Bhosari MIDC."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs ensure punctuality, safe driving, and a smooth commuting experience for all employees and executives."
  },
  {
    "WhyChooseheading": "24/7 Dedicated Corporate Support",
    "WhyChoosedescription": "Our support team is available round-the-clock to assist with urgent travel needs, schedule changes, and booking requests."
  },
  {
    "WhyChooseheading": "Quick & Hassle-Free Booking",
    "WhyChoosedescription": "Book your corporate cab for Bhosari MIDC easily through our online platform or phone, with quick confirmation and reliable service."
  }
]























  }

const faqData = [
  {
    question: 'Does Pune Corporate Cars India Private Limited provide corporate cab services in Bhosari MIDC?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers reliable and professional corporate cab services in Bhosari MIDC for employees and business travel.',
  },
  {
    question: 'How can companies in Bhosari MIDC book corporate cabs?',
    answer: 'Companies can book through our website, mobile app, or by contacting our dedicated 24×7 corporate support team.',
  },
  {
    question: 'Do you offer daily employee pick-up and drop services in Bhosari MIDC?',
    answer: 'Yes, we provide structured pick-up and drop services for employees working in Bhosari MIDC.',
  },
  {
    question: 'What types of vehicles are available for corporate travel in Bhosari MIDC?',
    answer: 'We offer hatchbacks, sedans, SUVs, and tempo travellers suitable for employee transportation and business meetings.',
  },
  {
    question: 'Can Bhosari MIDC companies opt for monthly cab contracts?',
    answer: 'Absolutely. We offer flexible monthly and yearly corporate cab contracts for companies in Bhosari MIDC.',
  },
  {
    question: 'Are your drivers familiar with Bhosari MIDC routes?',
    answer: 'Yes, our drivers are well-versed with Bhosari MIDC routes and ensure timely and safe transportation.',
  },
  {
    question: 'Do you provide cabs for shift-based operations in Bhosari MIDC?',
    answer: 'Yes, we support all shift timings including early morning and late-night shifts for MIDC companies.',
  },
  {
    question: 'What safety and hygiene standards do you maintain for corporate cabs?',
    answer: 'Our vehicles are sanitized regularly, and drivers follow strict hygiene and safety guidelines.',
  },
  {
    question: 'What payment methods are available for corporate cab services in Bhosari MIDC?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate invoices.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sagar Patil',
    feedback: 'Pune Corporate Cars India Private Limited has been extremely dependable for our Bhosari MIDC staff travel. Highly professional service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Jadhav',
    feedback: 'Their corporate cabs in Bhosari MIDC are punctual and well-maintained. Great experience overall.',
    rating: 5,
  },
];














































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Bhosari MIDC",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cabs-bhosari.jpg", // replace with actual image URL
  "description": "Reliable corporate cab services in Bhosari MIDC, Pune, offering employee transport, industrial area commute, office and factory pickup and drop, and business travel cabs. Pune Corporate Cars India Private Limited provides chauffeur-driven sedans, SUVs, and outstation cabs for companies and factories in Bhosari.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.8",  // update if needed
    "ratingCount": "4500", // update if needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500", // starting price, adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-services-bhosari-midc"
  }
};





  return (
    <div>
<Helmet>
  <title>Corporate Cab Services in Bhosari MIDC | Employee & Industrial Cabs | Pune Corporate Cars India Private Limited</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Bhosari MIDC, Pune, offering employee transport, industrial area commute, office and factory pickup and drop, and business travel cabs. Pune Corporate Cars India Private Limited provides chauffeur-driven sedans, SUVs, and outstation cabs for companies and factories in Bhosari."
  />

  <meta
    name="keywords"
    content="Bhosari Employee Transport, Bhosari Industrial Cab Service, Company Staff Cab Bhosari, Factory Worker Pickup Drop Bhosari, Corporate Shuttle Bhosari, Business Taxi Bhosari MIDC, Employee Commute Bhosari, Monthly Cab Service Bhosari, Best Corporate Cabs Bhosari, Affordable Office Cabs Bhosari, Bhosari Industrial Fleet Service, Bhosari Outstation Cab, Sedan Cab Bhosari MIDC, SUV Cab Bhosari MIDC, Corporate Fleet Provider Bhosari"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/16.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinbhosarimidc;